/**
 * Stable CSS class names for E2E — Lost cargo (lost package shipments).
 */
export const LOSTCARGO = {
    page: 'lost-cargo-page',
    breadcrumbSection: 'lost-cargo-page__breadcrumb-section',
    loadingSection: 'lost-cargo-page__loading-section',
    resultsSection: 'lost-cargo-page__results-section',
    toolbarRow: 'lost-cargo-page__toolbar-row',
    inputButtonBulkPrint: 'lost-cargo-page-input--button-bulk-print',
    inputButtonSelectAll: 'lost-cargo-page-input--button-select-all',
    toolbarActionsEnd: 'lost-cargo-page__toolbar-actions-end',
    inputButtonDetailedSearch: 'lost-cargo-page-input--button-detailed-search',
    toolbarExcelWrap: 'lost-cargo-page__excel-download-wrap',
    gridWrap: 'lost-cargo-page__grid-wrap',
    notFoundPanel: 'lost-cargo-page__not-found-panel',
    notFoundTitle: 'lost-cargo-page__not-found-title',
    notFoundHint: 'lost-cargo-page__not-found-hint',
    notFoundList: 'lost-cargo-page__not-found-list',
    rowOverdue: 'lost-cargo-datagrid-row--overdue',

    emptyStateWrap: 'lost-cargo-page__empty-state',
    inputButtonEmptySearch: 'lost-cargo-page-input--button-empty-search',

    datagridStatusButtonsWrap: 'lost-cargo-datagrid-cell--status-buttons',
    inputButtonRowPrint: 'lost-cargo-datagrid-input--button-row-print',
    inputButtonRowCancel: 'lost-cargo-datagrid-input--button-row-cancel',
    datagridLinkOrder: 'lost-cargo-datagrid-input--link-order-detail',
    datagridLinkInvoiceCargo: 'lost-cargo-datagrid-input--link-invoice-cargo-company',
    datagridLinkInvoiceCustomer: 'lost-cargo-datagrid-input--link-invoice-customer',

    searchDrawerPaper: 'lost-cargo-search-drawer',
    searchDrawerBody: 'lost-cargo-search-drawer__body',
    searchDrawerHeader: 'lost-cargo-search-drawer__header',
    searchDrawerTitle: 'lost-cargo-search-drawer__title',
    inputIconSearchDrawerClose: 'lost-cargo-search-drawer-input--icon-close',
    searchDrawerForm: 'lost-cargo-search-drawer__form',
    searchDrawerDateRow: 'lost-cargo-search-drawer__date-row',
    searchDrawerDateRangeWrap: 'lost-cargo-search-drawer__date-range',
    inputDateSearchStart: 'lost-cargo-search-drawer-input--date-start',
    inputDateSearchEnd: 'lost-cargo-search-drawer-input--date-end',
    searchDrawerOnlyTwentyOneDaysRow: 'lost-cargo-search-drawer__only-twenty-one-days-row',
    inputSwitchOnlyTwentyOneDays: 'lost-cargo-search-drawer-input--switch-only-twenty-one-days',
    searchDrawerRequiredHint: 'lost-cargo-search-drawer__required-hint',
    searchDrawerCargoCompanyField: 'lost-cargo-search-drawer__cargo-company-field',
    inputSelectSearchCargoCompanies: 'lost-cargo-search-drawer-input--select-cargo-companies',
    searchDrawerShipmentStatusField: 'lost-cargo-search-drawer__shipment-status-field',
    inputSelectSearchShipmentStatus: 'lost-cargo-search-drawer-input--select-shipment-status',
    inputTextCargoInvoiceNo: 'lost-cargo-search-drawer-input--text-cargo-invoice-no',
    inputTextCustomerInvoiceNo: 'lost-cargo-search-drawer-input--text-customer-invoice-no',
    inputTextCargoShipmentNo: 'lost-cargo-search-drawer-input--text-cargo-shipment-no',
    inputTextCustomerShipmentNo: 'lost-cargo-search-drawer-input--text-customer-shipment-no',
    searchDrawerFooter: 'lost-cargo-search-drawer__footer',
    inputButtonSearchClear: 'lost-cargo-search-drawer-input--button-clear',
    inputButtonSearchFilter: 'lost-cargo-search-drawer-input--button-filter',
} as const;

export const lostCargoCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
